import React from 'react';

import { getTranslateFunc } from '../../utils/stringUtil';
import IbModal from '../common/IbModal';
import IbIcon from '../common/IbIcon';

import {
  MAIN_CLASS_NAME,
  CONTENT_CLASS_NAME,
  SUCCESS_CLASS_NAME,
  ICON_CLASS_NAME,
  HEADER_CLASS_NAME,
  DESCRIPTION_CLASS_NAME,
} from './const';

interface ISuccessPanelProps {
  group: string;
  visible: boolean;
  loading?: boolean;
  onClose?: () => void;
}

const SuccessPanel: React.FC<ISuccessPanelProps> = ({ group, visible, loading, onClose }) => {
  const translate = getTranslateFunc(`${group}: Success:`);

  return (
    <IbModal className={MAIN_CLASS_NAME} loading={loading} visible={visible} onCancel={onClose}>
      <div className={`${CONTENT_CLASS_NAME} ${SUCCESS_CLASS_NAME}`}>
        <div className={ICON_CLASS_NAME}>
          <IbIcon iconName="check-one" size={64} />
        </div>
        <div className={HEADER_CLASS_NAME}>
          <div>{translate('Header: Line-1')}</div>
          <div>{translate('Header: Line-2')}</div>
        </div>
        <div className={DESCRIPTION_CLASS_NAME}>
          <div>{translate('Description: Line-1')}</div>
          <div>{translate('Description: Line-2')}</div>
        </div>
      </div>
    </IbModal>
  );
};

export default SuccessPanel;
